import {
  //
  ADD_BUNDLES,
  ADD_BUNDLES_FAILURE,
  ADD_BUNDLES_SUCCESS,
  //
  DELETE_BUNDLES,
  DELETE_BUNDLES_FAILURE,
  DELETE_BUNDLES_SUCCESS,
  //
  EDIT_BUNDLES,
  EDIT_BUNDLES_FAILURE,
  EDIT_BUNDLES_SUCCESS,
  //
  FETCH_BUNDLES,
  FETCH_BUNDLES_FAILURE,
  FETCH_BUNDLES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  GET_SUBS,
  GET_SUBS_SUCCESS,
  GET_SUBS_FAILURE,
  //
  ADD_SUB,
  ADD_SUB_SUCCESS,
  ADD_SUB_FAILURE,
} from "./constants";

// List
export const fetchBundles = (payload) => ({
  type: FETCH_BUNDLES,
  payload,
});
export const fetchBundlesSuccess = (payload) => ({
  type: FETCH_BUNDLES_SUCCESS,
  payload,
});
export const fetchBundlesFailure = (payload) => ({
  type: FETCH_BUNDLES_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onGetSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onGetSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addBundle = (payload) => ({
  type: ADD_BUNDLES,
  payload,
});
export const addBundleSuccess = (payload) => ({
  type: ADD_BUNDLES_SUCCESS,
  payload,
});
export const addBundleFailure = (payload) => ({
  type: ADD_BUNDLES_FAILURE,
  payload,
});
// EDIT
export const editBundle = (payload) => ({
  type: EDIT_BUNDLES,
  payload,
});
export const editBundleSuccess = (payload) => ({
  type: EDIT_BUNDLES_SUCCESS,
  payload,
});
export const editBundleFailure = (payload) => ({
  type: EDIT_BUNDLES_FAILURE,
  payload,
});
// DELETE
export const deleteBundle = (payload) => ({
  type: DELETE_BUNDLES,
  payload,
});
export const deleteBundleSuccess = (payload) => ({
  type: DELETE_BUNDLES_SUCCESS,
  payload,
});
export const deleteBundleFailure = (payload) => ({
  type: DELETE_BUNDLES_FAILURE,
  payload,
});
//
export const getSubs = (payload, onGet) => ({
  type: GET_SUBS,
  payload,
  onGet,
});
export const getSubsSuccess = (payload) => ({
  type: GET_SUBS_SUCCESS,
  payload,
});
export const getSubsFailure = (payload) => ({
  type: GET_SUBS_FAILURE,
  payload,
});
//
export const addSub = (payload, onSuccess) => ({
  type: ADD_SUB,
  payload,
  onSuccess,
});
export const addSubSuccess = (payload) => ({
  type: ADD_SUB_SUCCESS,
  payload,
});
export const addSubFailure = (payload) => ({
  type: ADD_SUB_FAILURE,
  payload,
});
